import React, {useMemo} from "react";

import PreFooter from "@components/Prefooter/PreFooter";
import {useDismissOverlayOnMount} from "@commons/Hooks";
import KvBanner from "@components/KvBanner/KvBanner";
import {findFirstSection, getCmsPage} from "@lib/Cms/CmsUtils";
import {SECTION_TYPE} from "@lib/Cms/CmsModels";
import BoostsPreview from "@components/Boost/BoostsPreview/BoostsPreview";
import CatalogPreview from "@components/Catalog/CatalogPreview/CatalogPreview";
import Page from "@components/Page/Page";
import PageContent from "@components/Page/PageContent";

export default function HomePage() {

    useDismissOverlayOnMount();

    const {banner, sections} = useMemo(() => getCmsPage("homepage") ?? {}, []);

    const boostSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.BOOSTS_PREVIEW), [sections]);
    const catalogSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.CATALOG_PREVIEW), [sections]);
    const preFooterSection = useMemo(() => findFirstSection(sections, SECTION_TYPE.PRE_FOOTER), [sections]);

    return (
        <>
            <Page>

                {!!banner &&
                    <KvBanner name={"hp"} banner={banner}/>
                }

                <PageContent>

                    {!!boostSection && <BoostsPreview cms={boostSection}/>}

                    {!!catalogSection && <CatalogPreview cms={catalogSection}/>}

                </PageContent>

            </Page>

            {!!preFooterSection && <PreFooter cms={preFooterSection}/>}
        </>
    );
}
